import React from 'react';
import PropTypes from 'prop-types';

import {
  TabsList,
  TabButton,
  TabIcon,
  TabLabel
} from './styled';

const SelectionTabs = ({
  ariaLabel,
  options,
  value,
  onChange
}) => {
  return (
    <TabsList aria-label={ ariaLabel } role="tablist">
      {options.map(({ value: optionValue, label, icon: IconComponent }) => {
        const isActive = value === optionValue;

        return (
          <TabButton
            key={ optionValue }
            $active={ isActive }
            aria-selected={ isActive }
            onClick={ () => onChange(optionValue) }
            role="tab"
            tabIndex={ isActive ? 0 : -1 }
            type="button"
          >
            {IconComponent && (
              <TabIcon $active={ isActive }>
                <IconComponent />
              </TabIcon>
            )}
            <TabLabel $active={ isActive }>
              {label}
            </TabLabel>
          </TabButton>
        );
      })}
    </TabsList>
  );
};

SelectionTabs.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.elementType
  })).isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default SelectionTabs;
